import { render } from "./ApplicationDomains.vue?vue&type=template&id=98eb81ba&scoped=true"
import script from "./ApplicationDomains.vue?vue&type=script&lang=js"
export * from "./ApplicationDomains.vue?vue&type=script&lang=js"

import "./ApplicationDomains.vue?vue&type=style&index=0&id=98eb81ba&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98eb81ba"]])

export default __exports__